"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "nimis": {
    "d5a21298": [{
      "hkey": "148bcd28",
      "slug": "torlano-ramandolo",
      "name": "Torlano-Ramandolo",
      "primary": true,
      "skipSearch": false
    }],
    "ramandolo": [{
      "hkey": "148bcd28",
      "slug": "torlano-ramandolo",
      "name": "Torlano-Ramandolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "nimis"
    }],
    "201b1cd1": [{
      "hkey": "148bcd28",
      "slug": "torlano-ramandolo",
      "name": "Torlano-Ramandolo",
      "primary": true,
      "skipSearch": false
    }],
    "torlano": [{
      "hkey": "148bcd28",
      "slug": "torlano-ramandolo",
      "name": "Torlano-Ramandolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;